module.exports = __webpack_public_path__ + "static/img/tst2-01.89978f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-01.jpg
// module id = cKSc
// module chunks = 1